import React from "react";
import YourPlans from "@/components/YourPlans";
import BrokeragePlan from "@/components/BrokeragePlan";
import Payments from "@/pages/Payments";
import "./PlansBilling.scss";

const PlansBilling = ({ addNewCard = false, isBlsAgent = false, brokerages = [], brokerageId = null }) => (
  <div className="plans-billing">
    {isBlsAgent ? <YourPlans withBrokerage={!(brokerages.length && brokerageId)} /> : null}
    {brokerages.length && brokerageId ? <BrokeragePlan brokerageId={brokerageId} /> : null}
    <Payments currentTab="payments" addNewCard={addNewCard} />
  </div>
);

export default PlansBilling;
